import React from "react";
import "../styles/DependentCardStyles.css";

const requestTypeColors = {
  1: "green",
  2: "red",
  3: "blue",
  default: "gray",
};

const getRequestType = (type) => {
  switch (type) {
    case 1:
      return "Addition";
    case 2:
      return "Deletion";
    case 3:
      return "Correction";
    default:
      return "-";
  }
};

const formatDate = (dateString) => {
  if (!dateString) return "-"; // Handle empty values

  const date = new Date(dateString);
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

const DependentCard = ({ data }) => {
  return (
    <div className="repo-loki-dependent">
      {data.map((item, index) => {
        const requestType = getRequestType(item.enrollment_type);
        const requestColor =
          requestTypeColors[item.enrollment_type] || requestTypeColors.default;

        return (
          <div key={index} className="dependent-card-custom">
            <div
              className="card-border-custom"
              style={{ border: `3px solid ${requestColor}` }}
            ></div>
            <div className="card-content-custom">
              <div className="card-header-custom">
                <h2 className="card-title-custom">{item.name || "-"}</h2>
                <span
                  className="request-type-custom"
                  style={{ color: requestColor }}
                >
                  {requestType}
                </span>
              </div>

              <div className="info-grid-custom">
                <div className="info-row-custom">
                  <div className="info-item-custom">
                    <p className="info-label-custom">Gender</p>
                    <p className="info-value-custom">{item.gender || "-"}</p>
                  </div>
                  <div className="info-item-custom">
                    <p className="info-label-custom">Relationship</p>
                    <p className="info-value-custom">
                      {item.relationship || "-"}
                    </p>
                  </div>
                </div>
                <div className="separator-custom"></div>
                <div className="info-row-custom">
                  <div className="info-item-custom">
                    <p className="info-label-custom">Date of Birth</p>
                    <p className="info-value-custom">
                      {formatDate(item.date_of_birth)}
                    </p>
                  </div>
                  <div className="info-item-custom">
                    <p className="info-label-custom">Age</p>
                    <p className="info-value-custom">{item.age || "-"}</p>
                  </div>
                </div>
              </div>

              {item?.remarks?.trim() && (
                <div className="repo-cover-remark-loki">
                  <p>
                    <span>Remarks</span>: {item.remarks}
                  </p>
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default DependentCard;
